import React__default, { useRef, useEffect } from 'react';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import { Zindexes } from '../../../theme/Zindexes.es.js';
import { useClickOutside } from '../../../hooks/useClickOutside.es.js';
import { useIntersect } from '../../../hooks/useIntersect.es.js';

const root = "_root_1aftq_15";
const menuOpen = "_menu-open_1aftq_1";
const box = "_box_1aftq_40";
const styles = {
	root: root,
	menuOpen: menuOpen,
	box: box
};

function getBackgroundColor(hasWhiteBackground = false) {
  return hasWhiteBackground ? "#fff" : Colors.BackgroundWeaker;
}
const FloatingBox = ({ children, hasWhiteBackground = void 0, intersectHeight = void 0, maxWidth = void 0, minWidth = void 0, onClickOutside = () => {
}, align = "left", position = void 0, borderRadius, borderColor = Colors.StrokeWeaker }) => {
  const threshold = 0.9;
  const node = useRef(null);
  const [setIntersectNode, { isBottomIntersecting, isTopIntersecting }] = useIntersect({
    heightOverride: intersectHeight,
    once: true,
    threshold
  });
  const backgroundColor = getBackgroundColor(hasWhiteBackground);
  const [setClickOutsideNode] = useClickOutside({
    onClickOutside
  });
  useEffect(() => {
    setIntersectNode(node.current);
    setClickOutsideNode(node.current);
  }, [setClickOutsideNode, setIntersectNode]);
  const derivedState = {
    position: position || (isTopIntersecting || !isBottomIntersecting ? "south" : "north")
  };
  return React__default.createElement(
    "div",
    { className: styles.root, "data-align": align, "data-position": derivedState.position, ref: node, "data-testid": "floating-box", "data-zds": true, style: {
      "--_zds-floating-box-max-width": maxWidth !== null && maxWidth !== void 0 ? maxWidth : "",
      "--_zds-floating-box-min-width": minWidth !== null && minWidth !== void 0 ? minWidth : "",
      "--_zds-floating-box-z-index": Zindexes.dropdownMenu
    } },
    React__default.createElement("div", { className: styles.box, style: {
      "--_zds-floating-box-background-color": backgroundColor,
      "--_zds-floating-box-border-color": borderColor,
      "--_zds-floating-box-border-radius": `var(--zds-radius-${borderRadius !== null && borderRadius !== void 0 ? borderRadius : "default"})`
    } }, children)
  );
};

export { FloatingBox };
//# sourceMappingURL=FloatingBox.es.js.map
